import {templateURI} from "./app";

window.addEventListener('DOMContentLoaded', (event) => {
    let lang = 'en'
    let role = '研究者の方'

    //validate
    function validateFromEmail(form, data) {
        const flag = {}
        let priority = 0
        Object.keys(data).map(name => {
            flag[name] = true
        })

        let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/s;
        let half_width = /^[0-9]+$/;
        let check_phone = /^[\+\(\s.\-\/\d\)]{5,30}$/s;
        Object.keys(data).map(item => {
            if (item === 'full_name' && !data[item]) {
                form.find('#msg-full-name').text(lang === 'en' ? 'Please enter your full name.' : 'お名前を入力してください。');
                flag[item] = false
                priority = 1
            }
            if (item === 'email') {
                if (!data[item]) {
                    form.find('#msg-email').text(lang === 'en' ? 'Please enter your e-mail address.' : 'メールアドレスを入力してください');
                    flag[item] = false
                    if (priority !== 1)
                        priority = 2
                } else if (emailReg.test(data[item]) === false) {
                    form.find('#msg-email').text(lang === 'en' ? 'Please enter a vailed Email adress' : '有効なメールアドレスを入力してください。');
                    flag[item] = false
                    if (priority !== 1)
                        priority = 2
                }

            }
            if (item === 'confirm_email') {
                if (!data[item]) {
                    form.find('#msg-confirm').text(lang === 'en' ? 'Please enter a vailed Email adress (confirmation).' : '有効なメールアドレスを入力してください。');
                    flag[item] = false
                    if (priority > 3 || priority === 0)
                        priority = 3
                } else if (data[item] !== data['email']) {
                    form.find('#msg-confirm').text(lang === 'en' ? 'Enter the same Email address for the e-mail address and the Email address (confirmation).' : 'メールアドレスとメールアドレス（確認用）には、同じメールアドレスを入力してください。');
                    flag[item] = false
                    if (priority > 3 || priority === 0)
                        priority = 3
                }

            }
            if (item === 'phone_number' && data[item]) {
                if (!check_phone.test(data[item])) {
                    form.find('#msg-phone-num').text(lang === 'en' ? 'Only single-byte numbers can be used.' : '半角数字のみ利用できます。');
                    if (priority > 4 || priority === 0)
                        priority = 4
                    flag[item] = false
                }
            }
            if (item === 'zip_code' && data[item]) {
                if (!half_width.test(data[item])) {
                    form.find('#msg-zip-code').text(lang === 'en' ? 'Only single-byte numbers can be used.' : '半角数字のみ利用できます。');
                    if (priority > 5 || priority === 0)
                        priority = 5
                    flag[item] = false
                }
            }
            if (item === 'inq' && !data[item]) {
                form.find('#msg-inq').text(lang === 'en' ? 'Please enter your inquiry' : 'お問合せ内容を入力してください。');
                if (priority === 0)
                    priority = 6
                flag[item] = false
            }
        })
        if (priority === 1) {
            form.find('#full-name').focus()
        } else if (priority === 2) {
            form.find('#email').focus()
        } else if (priority === 3) {
            form.find('#confirm-email').focus()
        } else if (priority === 4) {
            form.find('#phone-number').focus()
        } else if (priority === 5) {
            form.find('#zip-code').focus()
        } else if (priority === 6) {
            form.find('#inq ').focus()
        }

        return Object.keys(flag).every(name => {
            return flag[name]
        })
    }

    let isSubmitForm = false

    function sendContact(form, event) {
        if (!isSubmitForm) {
            isSubmitForm = true
            lang = event.target.getAttribute('data-lang')
            role = event.target.getAttribute('data-role')
            let select = form.find("#selectBox");
            let organization_name = form.find('#organization-name');
            let department = form.find('#department');
            let job = form.find('#job');
            let full_name = form.find('#full-name');
            let email = form.find('#email');
            let confirm_email = form.find('#confirm-email');
            let phone_number = form.find('#phone-number');
            let address = form.find('#address');
            let zip_code = form.find('#zip-code');
            let inq = form.find('#inq');
            form.find('#msg-full-name').text('');
            form.find('#msg-email').text('')
            form.find('#msg-confirm').text('');
            form.find('#msg-phone-num').text('');
            form.find('#msg-zip-code').text('');
            form.find('#msg-inq').text('');
            let data = {
                role: role,
                category: select.val(),
                organization_name: organization_name.val(),
                department: department.val(),
                job: job.val(),
                full_name: full_name.val(),
                email: email.val(),
                confirm_email: confirm_email.val(),
                phone_number: phone_number.val(),
                zip_code: zip_code.val(),
                address: address.val(),
                inq: inq.val(),
            }
            // console.log(data)

            const btnSubmit = form.find('#submit-contact')
            const oldText = btnSubmit.html()
            const loadingHtml = `<img class="image" style="height: 32px" src="${templateURI('resources/com/loading.svg')}">`
            btnSubmit.html(loadingHtml)

            if (validateFromEmail(form, data)) {
                $.ajax({
                    type: "post",
                    dataType: 'json',
                    async: true,
                    url: "/wp-admin/admin-ajax.php",
                    data: {
                        action: "sendEmail",
                        data: data
                    },
                    beforeSend: () => {
                    },
                    success: (response) => {
                        organization_name.val('')
                        department.val('')
                        job.val('')
                        full_name.val('')
                        email.val('')
                        confirm_email.val('')
                        phone_number.val('')
                        address.val('')
                        zip_code.val('')
                        inq.val('')
                        btnSubmit.html(oldText)

                        setTimeout(() => {
                            if (typeof Swal != "undefined")
                                Swal.fire(
                                    'ありがとうございました。',
                                    'お問い合わせメールは送信されました。',
                                ).then(() => {
                                    isSubmitForm = false
                                })
                            else
                                isSubmitForm = false
                        })
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        btnSubmit.html(oldText)
                        isSubmitForm = false
                    }
                })
            } else {
                isSubmitForm = false
                btnSubmit.html(oldText)
            }
        }
    }

    $("#form-contact1").submit(function (event) {
        event.preventDefault()
        sendContact($(this), event)

    })

    $("#form-contact2").submit(function (event) {
        event.preventDefault()

        sendContact($(this), event)
    })

    $("#form-contact3").submit(function (event) {
        event.preventDefault()

        sendContact($(this), event)
    })

    $("#form-contact4").submit(function (event) {
        event.preventDefault()

        sendContact($(this), event)
    })
})
